/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { attributes } = props;
	const { blockClientId } = attributes;
	return (
		<div { ...useBlockProps.save( {
			className: classnames( `gutenify-section-${ blockClientId }` ),
			'data-xxx': classnames( `gutenify-section-${ blockClientId }` ),
		} ) } >
			<InnerBlocks.Content />
		</div>
	);
}
